var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaby9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-266 -4230)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(266 4230)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280.07 4246)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.462 25.856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.647,386.041a7.073,7.073,0,0,0-4.754,0l-4.107,3.843,2.355,3.213H162.4l2.356-3.213A7.107,7.107,0,0,0,160.647,386.041Z",
    transform: "translate(-151.2 -385.63)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.27,385.63a7.067,7.067,0,0,0-6.484,4.255l2.355,3.213h1.205v-.4a7.573,7.573,0,0,1,4.469-6.9A7.068,7.068,0,0,0,158.27,385.63Z",
    transform: "translate(-151.2 -385.63)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.046,391.765a4.926,4.926,0,0,0,2.377,2.563,4.926,4.926,0,0,0,2.377-2.563Z",
    transform: "translate(-208.353 -391.765)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.987,450.794q-.158-.094-.314-.192a16.006,16.006,0,0,1-2.041-1.515,7.028,7.028,0,0,0-.586,2.816v.4h2.941v-1.505Z",
    transform: "translate(-143.046 -445.244)",
    fill: "#ffbf9d"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.949)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.792,
    cy: 2.792,
    r: 2.792,
    transform: "translate(1 2)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.792,
    cy: 2.792,
    r: 2.792,
    transform: "translate(26.481 2)",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.266,0,51.026,13.241l5.934,8.113a12,12,0,0,0,9.683,4.914A13.229,13.229,0,0,0,77.507,13.24Z",
    transform: "translate(-47.734)",
    fill: "#ffd4bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.415,197.476H51.026A13.249,13.249,0,0,0,66.643,210.5,13.372,13.372,0,0,1,55.415,197.476Z",
    transform: "translate(-47.734 -184.235)",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.966,89.113l-3.385,1.711-1.045,3.044a10.073,10.073,0,0,0,6.6,2.51A13.178,13.178,0,0,0,351.966,89.113Z",
    transform: "translate(-327.654 -83.138)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.724,16.105a17.541,17.541,0,0,1-2.7,1.446,13.262,13.262,0,0,0-1.812-1.164L105.4,18.956l2.753,8.52a.872.872,0,0,0,.83.6l4.787,0a14.632,14.632,0,0,0,13.745-10.659,1.184,1.184,0,0,0-1.791-1.313Z",
    transform: "translate(-101.754 -14.84)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.461.181A13.265,13.265,0,0,0,54.672,4.116a13.2,13.2,0,0,0-3.646,9.124h7.228a3.615,3.615,0,0,1-.439-2.947,11.174,11.174,0,0,1,8.977-8.128l3.691-.618A13.138,13.138,0,0,0,66.461.181Z",
    transform: "translate(-51.026 0)",
    fill: "#463c4b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.336 14.448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.5,215.481a.5.5,0,0,0-.5.5v.9a.5.5,0,0,0,1.006,0v-.9A.5.5,0,0,0,171.5,215.481Z",
    transform: "translate(-171 -215.481)",
    fill: "#313d40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.5,215.481a.5.5,0,0,0-.5.5v.9a.5.5,0,0,0,1.006,0v-.9A.5.5,0,0,0,311.5,215.481Z",
    transform: "translate(-301.613 -215.481)",
    fill: "#313d40"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.432,449.086a16.08,16.08,0,0,1-2.356,1.708V452.3h2.942v-.4A7.026,7.026,0,0,0,312.432,449.086Z",
    transform: "translate(-289.415 -418.975)",
    fill: "#ffd4bd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,223.261a3.315,3.315,0,0,1-3.166-3.44.449.449,0,0,1,.452-.446h5.427a.449.449,0,0,1,.452.446,3.315,3.315,0,0,1-3.166,3.44Zm0,0",
    transform: "translate(-170.469 -199.514)",
    fill: "#fb8276"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby9);
export default __webpack_public_path__ + "static/media/baby9.6a99a0b5ccaa53c50ee2f8b1bd2371fe.svg";
export { ForwardRef as ReactComponent };